/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component, ChangeDetectionStrategy, Input, Inject,
} from '@angular/core';

interface User {
  id: number;
  slug: string;
  name: string;
  avatar_url: string;
  points: number;
  badges: Array<{ badge_type: string }>;
  current_user_permissions: { [key: string]: boolean };
}

interface BadgeInfo {
  name: string;
  icon: string;
}

@Component({
  selector: 'ut-feed-leaderboard',
  templateUrl: './feed-leaderboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FeedLeaderboardComponent {
  @Input() user!: User;

  badgePresentation: { [key: string]: BadgeInfo } = {};

  constructor(
    @Inject('GamificationService') private GamificationService: any,
  ) {
    if (this.GamificationService) {
      this.badgePresentation = this.GamificationService.badgesById;
    }
  }

  getBadgeTitle(badgeType: string): string {
    return this.badgePresentation[badgeType]?.name || '';
  }

  getBadgeIcon(badgeType: string): string {
    return this.badgePresentation[badgeType]?.icon || '';
  }
}
